import { type FC, type ReactNode } from 'react';

import { cn } from '@/shared/libs';

export interface PageHeaderProps {
  action?: ReactNode;
  className?: string;
  subtitle?: string;
  title: string;
}

export const PageHeader: FC<PageHeaderProps> = ({
  action,
  className,
  subtitle,
  title,
}) => (
  <div
    className={cn(
      'flex flex-wrap items-start justify-between gap-3',
      className,
    )}>
    <div className="min-w-0 flex-1">
      <h1 className="break-words text-xl font-semibold tracking-tight md:text-3xl">
        {title}
      </h1>
      {!!subtitle && (
        <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>
      )}
    </div>
    {!!action && (
      <div className="flex shrink-0 items-center gap-2">{action}</div>
    )}
  </div>
);

PageHeader.displayName = 'PageHeader';
